import React, { Component } from 'react';
export default class Intro extends Component {
    render() {
      return (
        <React.Fragment>
        {/*generated code*/}
            <section id="intro">   
            <div className="intro-overlay" />	
            <div className="intro-content">
            <div className="row">
                <div className="col-twelve">
                <h5>Hello, World.</h5>
                <h1>I'm Nick Hill G<a href="https://theuselessweb.site/">.</a></h1>
                <p className="intro-position">
                    <span><a href="https://miro.medium.com/max/875/1*T7xnr9bfEMsbzaiUJe2n_w.jpeg">Developer</a></span>
                    <span><a href="https://4.bp.blogspot.com/-Dm1aVhDE2ZY/Xzu9x-aQWGI/AAAAAAAAR0E/VSAV4EK_we0-3VjmHTXAjJx1KAOFoznnwCLcBGAsYHQ/s1600/data-never-sleeps-8-infographic-2020.png">Evangelist</a></span>
                    <span><a href="https://cdn.slidesharecdn.com/ss_thumbnails/whatisnumerologyebook-190904230242-thumbnail-4.jpg?cb=1567638703">Numerophile</a></span>  
                </p>
                <a className="button stroke smoothscroll" href="#about" title>Know Me</a>
                </div>  
            </div>   		 		
            </div> {/* /intro-content */} 
            <ul className="intro-social">        
            <li><a href="https://www.facebook.com/peddygriano/"><i className="fa fa-facebook" /></a></li>
            <li><a href="https://www.linkedin.com/in/nicknshe/"><i className="fa fa-linkedin" /></a></li>
            <li><a href="https://twitter.com/snickeret"><i className="fa fa-twitter" /></a></li>
            <li><a href="https://www.reddit.com/user/prawnick"><i className="fa fa-reddit" /></a></li>
            <li><a href="https://www.instagram.com/im_nicksome/"><i className="fa fa-instagram" /></a></li>
            </ul> {/* /intro-social */}      	
        </section> {/* /intro */}
        </React.Fragment>
      );
    }
  }
